import { Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { PaymentLinkDialogContentProps } from '../types';
import { OwnerInfoRow } from './OwnerInfoRow';
import { ServiceOrderNumberInfoRow } from './ServiceOrderNumberInfoRow';
import { ServiceOrderDatesInfoRow } from './ServiceOrderDatesInfoRow';
import { BillAmountInfoRow } from './BillAmountInfoRow';
import { PaymentAmountInfoRow } from './PaymentAmountInfoRow';
import { PaymentTypeInfoRow } from './PaymentTypeInfoRow';

export const PaymentLinkDetails = ({
    accountId,
    serviceOrderId,
    paymentId,
    billAmount,
}: Omit<PaymentLinkDialogContentProps, 'formRef'>) => (
    <>
        <Typography textStyle="titleMediumStrong" as="div">
            {lt('DetailPlural')}
        </Typography>
        <Stack vertical spacing="200">
            <OwnerInfoRow accountId={accountId} />
            {serviceOrderId ? (
                <>
                    <ServiceOrderNumberInfoRow serviceOrderId={serviceOrderId} />
                    <ServiceOrderDatesInfoRow serviceOrderId={serviceOrderId} />
                </>
            ) : null}
            {billAmount ? <BillAmountInfoRow billAmount={billAmount} /> : null}
            <PaymentAmountInfoRow paymentId={paymentId} accountId={accountId} />
            <PaymentTypeInfoRow paymentId={paymentId} />
        </Stack>
    </>
);
